import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/index/index'
import shopCard from '@/components/card/shopCard'
import login from '@/components/login/login'
import register from '@/components/login/register'
import aboutMe from '@/components/about/me'
import contact from '@/components/about/contact'
import notice from '@/components/about/notice'
import opinion from '@/components/about/opinion'
import problem from '@/components/about/problem'
import flow from '@/components/about/flow'
import terrace from '@/components/about/terrace'
import terraceUser from '@/components/about/user'
import deal from '@/components/about/deal'
import declrea from '@/components/about/declrea'
import user from '@/components/user/user'
import withdraw from '@/components/user/withdraw'
import withdrawAccount from '@/components/user/withdrawAccount'
import order from '@/components/user/order'
import orderDetail from '@/components/user/orderDetail'
import withdrawList from '@/components/user/withdrawList'
import setting from '@/components/user/setting/setting'
import bindPhone from '@/components/user/setting/bindPhone'
import updatePhone from '@/components/user/setting/updatePhone'
import passWord from '@/components/user/setting/passWord'
import real from '@/components/user/setting/real'
import wx_login from '@/components/login/wx_login'
import face_detail from '@/components/user/face_detail'
import settle from '@/components/user/settle'
import survey from '@/components/user/survey'
import article from '@/components/article/index'
import articleDetail from '@/components/article/detail'
import statistics from '@/components/user/statistics'
Vue.use(Router)

const router = new Router({
　　mode:"hash",
　　routes:[
{ path:'/', name:'HelloWorld', component:Home,meta: { title: '吉吉收' }},
{ path:'/shop',name:'shopCard',component:shopCard,meta: { title: '我要卖卡' }},
{ path:'/login',name:'login',component:login,meta: { title: '登录' }},
{ path:'/register',name:'register',component:register,meta: { title: '注册' }},
{ path:'/aboutMe',name:'aboutMe',component:aboutMe,meta: { title: '公司简介' }},
{ path:'/contact',name:'contact',component:contact,meta: { title: '联系我们' }},
{ path:'/notice',name:'notice',component:notice,meta: { title: '平台公告' }},
{ path:'/opinion',name:'opinion',component:opinion,meta: { title: '意见反馈' }},
{ path:'/problem',name:'problem',component:problem,meta: { title: '常见问题' }},
{ path:'/flow',name:'flow',component:flow,meta: { title: '回收流程' }},
{ path:'/terrace',name:'terrace',component:terrace,meta: { title: '用户服务协议' }},
{ path:'/terraceUser',name:'terraceUser',component:terraceUser,meta: { title: '隐私保护政策' }},
{ path:'/deal',name:'deal',component:deal,meta: { title: '礼品卡转让协议' }},
{ path:'/declrea',name:'declrea',component:declrea,meta: { title: '礼品卡回收说明' }},
{ path:'/user',name:'user',component:user,meta: { title: '个人中心' }},
{ path:'/withdraw',name:'withdraw',component:withdraw,meta: { title: '我要提现' }},
{ path:'/withdrawAccount',name:'withdrawAccount',component:withdrawAccount,meta: { title: '提现账号管理' }},
{ path:'/order',name:'order',component:order,meta: { title: '我的订单' }},
{ path:'/orderDetail',name:'orderDetail',component:orderDetail,meta: { title: '订单详情' }},
{ path:'/withdrawList',name:'withdrawList',component:withdrawList,meta: { title: '提现记录' }},
{ path:'/setting',name:'setting',component:setting,meta: { title: '个人资料' }},
{ path:'/bindPhone',name:'bindPhone',component:bindPhone,meta: { title: '绑定手机' }},
{ path:'/updatePhone',name:'updatePhone',component:updatePhone,meta: { title: '修改手机' }},
{ path:'/passWord',name:'passWord',component:passWord,meta: { title: '修改密码' }},
{ path:'/real',name:'real',component:real,meta: { title: '实名认证' }},
{ path:'/wx_login',name:'wx_login',component:wx_login,meta: { title: '微信登录' }},
{ path:'/face_detail',name:'face_detail',component:face_detail,meta: { title: '资金明细' }},
{ path:'/settle',name:'settle',component:settle,meta: { title: '快速结算' }},
{ path:'/survey',name:'survey',component:survey,meta: { title: '尽职调查' }},
{ path:'/article',name:'article',component:article,meta: { title: '卡券新闻' }},
{ path:'/articleDetail',name:'articleDetail',component:articleDetail,meta: { title: '新闻详情' }},
{ path:'/statistics',name:'statistics',component:statistics,meta: { title: '销卡统计' }},
 ]
})

router.beforeEach((to, from, next) => {
  let settingPc = JSON.parse(localStorage.getItem('settingPc'))
  if(Object.keys(to.meta).length>0 && to.matched.length>0){
    let head = document.getElementsByTagName('head');

    let meta_keyword=document.createElement('meta');
    if(document.querySelector('meta[name="keywords"]')){
      document.querySelector('meta[name="keywords"]').setAttribute('content',settingPc?settingPc.seo_keywords:'')
    }else{
      meta_keyword.setAttribute('name','keywords')
      meta_keyword.setAttribute('content',settingPc?settingPc.seo_keywords:'')
      head[0].appendChild(meta_keyword)
    }
    let meta_description=document.createElement('meta');
    if(document.querySelector('meta[name="description"]')){
      document.querySelector('meta[name="description"]').setAttribute('content',settingPc?settingPc.seo_description:'')
    }else{
      meta_description.setAttribute('name','description')
      meta_description.setAttribute('content',settingPc?settingPc.seo_description:'')
      head[0].appendChild(meta_description)
    }
  }
  let link = settingPc && settingPc.icon_img.file_path?settingPc.icon_img.file_path:''
  let $favicon = document.querySelector('link[rel="icon"]');
  if ($favicon !== null) {
    $favicon.href = link;
  } else {
    $favicon = document.createElement("link");
    $favicon.rel = "icon";
    $favicon.href = link;
    document.head.appendChild($favicon);
  }
  if (to.meta.title) {
    document.title = to.meta.title
  }
	let code = to.query.code, state = to.query.state
	if(code){
		setTimeout(() => {
			const { href } = router.resolve({
			  path: '/user'
			});
			window.opener.location.href(href)
			window.close()

		},1000)

	}
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js